import { defineQuartzConfig } from 'quartz-config';
export default defineQuartzConfig({
  type: 'application',
  auth: 'none',
  historyBasename: '/academy/achievements',
  additionalDlbs: ['apollo-dlb/bundle.js'],
  theme: 'trellis-light',
  htmlTitle: 'HubSpot Academy',
  includeDefaultViewportMetaTag: true,
  createRootApi: true,
  logFetchErrors: {
    options: {
      ignoreErrors: [/Reagan/i, /usage-tracker event error: Could not identify user. Please specify either an email address or __hstc cookie identifer./i]
    }
  },
  initialPageLoadTracking: true,
  sessionResourceTracking: true,
  tracking: {
    provideLegacyDefaultPrimaryTracker: true
  }
});